import preloader from "../../img/preloader.svg";

const Preloader = () => {
  return <img src={preloader} alt="" />;
};

export { Preloader };
